
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useState } from 'react';




export default function EnderecoHist({
  enderecos
}: {
  enderecos: any
}) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState<any>(null);

  const abrirMapa = (endereco: any) => {
    setEnderecoSelecionado(endereco);
    setVisible(true);
  };

  const montarEnderecoCompleto = (endereco: any) => {
    const partes = [
      endereco.logradouro,
      endereco.numero,
      endereco.complemento,
      endereco.bairro,
      endereco.cidade,
      endereco.uf,
      endereco.cep
    ].filter(Boolean);
    return partes.join(', ');
  };

  const acaoTemplate = (rowData: any) => {
    return (
      <Button
        icon="pi pi-map-marker"
        className="p-button-rounded p-button-info p-button-text"
        tooltip="Ver no Mapa"
        tooltipOptions={{ position: 'top' }}
        onClick={() => abrirMapa(rowData)}
      />
    );
  };

  const footerContent = (
    <div>
      <Button label="Fechar" icon="pi pi-times" style={{ color: '#183462' }} onClick={() => setVisible(false)} className="p-button-text" />
    </div>
  );
  return (
    <Panel header={t('historicoEndereco')}>

      <DataTable size="small" value={enderecos} tableStyle={{ minWidth: '50rem' }}>
        <Column field="logradouro" header={t('logradouro')}></Column>
        <Column field="cep" header={t('cep')}></Column>
        <Column field="bairro" header={t('bairro')}></Column>
        <Column field="cidade" header={t('cidade')}></Column>
        <Column field="uf" header={t('uf')}></Column>
        <Column field="complemento" header={t('complemento')}></Column>
        <Column field="numero" header={t('numero')}></Column>
        <Column field="data" header={t('data')}></Column>
        <Column header={t('mapa')} body={acaoTemplate} style={{ width: '80px', textAlign: 'center' }}></Column>
      </DataTable>

      <Dialog
        header="Localização no Mapa"
        visible={visible}
        style={{ width: '80vw', maxWidth: '900px' }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        {enderecoSelecionado && (
          <div>
            <p style={{ marginBottom: '1rem' }}>
              <strong>Endereço:</strong> {montarEnderecoCompleto(enderecoSelecionado)}
            </p>
            <iframe
              className="no-print"
              title="Mapa do Endereço"
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: '8px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}`}
            />
            <img
              className="print-only"
              style={{ width: '100%', borderRadius: '8px', display: 'none' }}
              alt={`Mapa do endereço: ${montarEnderecoCompleto(enderecoSelecionado)}`}
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&zoom=15&size=600x400&markers=${encodeURIComponent(montarEnderecoCompleto(enderecoSelecionado))}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
            />
          </div>
        )}
      </Dialog>
    </Panel>
  )
}
